import firebase from "config/firebase";

export const getAllSportRequests =
  (lastDoc, onSuccess = () => {}) =>
  async (dispatch) => {
    dispatch({ type: "FETCH_SPORT_REQUESTS_PENDING" });
    try {
      const sportRequestsCollectionRef = firebase
        .firestore()
        .collection("requested_sports");
      const sportRequestsLimit = 5;

      let q = sportRequestsCollectionRef
        .orderBy("city", "asc")
        .limit(sportRequestsLimit);

      if (lastDoc) {
        q = q.startAfter(lastDoc);
      }

      const querySnapshot = await q.get();
      // const unsubscribe = q.onSnapshot((querySnapshot) => {
        const sportRequestsData = [];
        let lastVisible = null;

        querySnapshot.forEach((doc) => {
          sportRequestsData.push({ id: doc.id, ...doc.data() });
          lastVisible = doc;
        });

        const hasMoreSportRequests = querySnapshot.size > sportRequestsLimit;

        dispatch({
          type: lastDoc
            ? "FETCH_SPORT_REQUESTS_LOAD_MORE_SUCCESS"
            : "FETCH_SPORT_REQUESTS_SUCCESS",
          payload: {
            sportRequestsData,
            lastDoc: lastVisible,
            hasMoreSportRequests,
          },
        });

        onSuccess();
      // });

      // return unsubscribe;
    } catch (error) {
      console.error("Error fetching orders:", error.message);
      dispatch({
        type: "FETCH_SPORT_REQUESTS_REJECTED",
        error: error.message,
      });
      onSuccess();
    }
  };

export const sportRequestDelete =
  (id, onSuccess = () => {}) =>
  async (dispatch) => {
    await firebase.firestore().collection("requested_sports").doc(id).delete();

    onSuccess();
  };

export const acceptSportRequest =
  (obj, DocId, onSuccess = () => {}) =>
  async (dispatch) => {
    let data = await firebase.firestore().collection("sports").get();
    let newArr = data.docs.find((item) => {
      return item.data().sport == obj.sport;
    });

    if (newArr) {
      let concatArr = newArr.data().details.concat(obj.details);
      let newVal = await firebase
        .firestore()
        .collection("sports")
        .where("sport", "==", obj.sport)
        .get();
      let ID = newVal.docs[0].id;

      await firebase
        .firestore()
        .collection("sports")
        .doc(ID)
        .update({ details: concatArr });

      await firebase
        .firestore()
        .collection("requested_sports")
        .doc(DocId)
        .delete();

      onSuccess();
    } else {
      await firebase.firestore().collection("sports").add(obj);

      await firebase
        .firestore()
        .collection("requested_sports")
        .doc(DocId)
        .delete();

      onSuccess();
    }
  };
